const Galerea = () => {
  return <div>Galerea</div>;
};
export default Galerea;
